import { useEffect, useMemo } from 'react';
import _ from 'lodash';

import { PostData } from '../portal/model/PostTypes';

import {
    PortalLocalizationDTO,
    PortalSettingsDTO,
    usePortalLocalization,
} from './portal';
import { useSelectedLanguage } from './selectedLanugage';
import { useQAWebTool } from './useQAWebTool';

import { prepareGamePayload } from '../portal/portalUtils';
import { localizationArrayToRecord } from '../portal/translationUtils';

const PREVIEW_DEBOUNCE = 2000;
const COMMAND = 'Override Portal Payload';

export const usePreviewPortalPayload = (
    posts: PostData[] | PostData | undefined = [],
    opts: {
        leading?: boolean;
    } = { leading: true },
    settings?: PortalSettingsDTO,
    pendingLocalizations: PortalLocalizationDTO[] = [],
) => {
    const webTool = useQAWebTool();
    const { selectedLanguage } = useSelectedLanguage();

    const { data: savedLocalizations = [] } = usePortalLocalization();

    const localizationsRecord = useMemo(
        () =>
            // pending after saved → pending wins on duplicate (id, language)
            localizationArrayToRecord([
                ...savedLocalizations,
                ...pendingLocalizations,
            ]),
        [savedLocalizations, pendingLocalizations],
    );

    const sendCommand = useMemo(
        () =>
            _.debounce(webTool.sendCommand, PREVIEW_DEBOUNCE, {
                leading: opts.leading,
            }),
        [webTool.sendCommand, opts.leading],
    );

    useEffect(() => {
        const postsArray = Array.isArray(posts) ? posts : [posts];
        sendCommand(COMMAND, [
            JSON.stringify(
                prepareGamePayload(
                    postsArray,
                    selectedLanguage,
                    localizationsRecord,
                    settings,
                ),
            ),
        ]);
    }, [posts, settings, selectedLanguage, localizationsRecord, sendCommand]);
};
